import { Component, OnInit } from '@angular/core';
import { PricingService } from '../../services';
import { Message } from '../../classes/Message';
import { MessageService } from 'primeng';
import { InputHelper } from '../../utils/input.helper';

@Component({
  selector: 'manage-long-distance-time-bands',
  templateUrl: './manage-long-distance-time-bands.component.html',
  styleUrls: ['./manage-long-distance-time-bands.component.css'],
})
export class ManageLongDistanceTimeBandsComponent implements OnInit {
  constructor(
    private pricingService: PricingService,
    public messageService: MessageService,
    public inputHelper: InputHelper,
  ) {}

  timeBands: any[];
  selectedTimeBand: any;
  isLoaded: boolean;
  showAddTimeBandDlg: boolean;
  showDeleteTimeBandDlg: boolean;
  public addItem = { id: 0, timeBand: 0, addOnPrice: 0 };

  ngOnInit() {
    this.isLoaded = false;
    this.loadData();
  }

  loadData() {
    this.pricingService.getLongDistanceTimeBands().then((result) => {
      console.log('Timebands: ', result);
      this.timeBands = result;
      this.isLoaded = true;
    });
  }

  onRowClick(event: any) {
    this.selectedTimeBand = event.data;
  }

  cellEdit(item: any, index: number) {
    console.log('Editing cell finished, saving: ', item);

    if (index == 0 && (item.timeBand.trim() == '' || item.timeBand.trim() == '')) {
      this.messageService.add(Message.Error('Timeband cannot be empty', 'Error'));
      return;
    }
    if (index == 1 && (item.addOnPrice.trim() == '' || item.addOnPrice.trim() == '')) {
      this.messageService.add(Message.Error('Add-on Price cannot be empty', 'Error'));
      return;
    }

    // update the reduction in the db
    this.pricingService.updateLongDistanceTimeBand(item).catch((res) => {
      console.log(res);
    });
  }

  deleteTimeBand() {
    this.showDeleteTimeBandDlg = true;
  }

  deleteTimeBandConfirm(item) {
    this.pricingService
      .deleteLongDistanceTimeBand(item)
      .then((x) => {
        this.showDeleteTimeBandDlg = false;
        this.loadData();
      })
      .catch((err) => {
        this.messageService.add(Message.Error(err.message));
      });
  }

  addTimeBand() {
    this.addItem = {
      id: 0,
      timeBand: 0,
      addOnPrice: 0,
    };
    this.showAddTimeBandDlg = true;
  }

  saveTimeBand(addItem) {
    this.pricingService
      .addLongDistanceTimeBand(addItem)
      .then((result) => {
        this.showAddTimeBandDlg = false;
        this.loadData();
      })
      .catch((err) => {
        this.messageService.add(Message.Error(err.message));
      });
  }

  onGridLazyLoad($event: any) {}
}
